import { message, PageHeader, Popconfirm, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico, dineroDisabledMask } from "../../../Components/Items";
import GenerarVenta from "./GenerarVenta/GenerarVenta";
import CotizadorPlanBiwo from "./CotizadorPlanBiwo/CotizadorPlanBiwo";
import ModalDescargarDocumentos from "../../../Components/ModalDescargarDocumentos";
import descargarDocumentosMasivo, { MODULOS } from "../../../Components/DescargarDocumentosMasivo";
import { EditOutlined, ShoppingCartOutlined, CloseCircleOutlined, CopyOutlined, DownloadOutlined, CheckCircleOutlined } from "@ant-design/icons";

moment.locale("es");

class Cotizaciones extends Component {
    tableRef = null;
    state = {
        todasCotizaciones: [],
        loading: false,
        modalCancelacion: false,
        modalCancelacionId: null,
        modalEnvios: false,
        modalEnviosId: null,
        modalGenerarVenta: false,
        modalGenerarVentaId: null,
        valor: 1,
        textoFiltro: "",
        totalRecords: 0,
        cotizacionesSeleccionadas: [],
        objetoCotizacionesEncontradas: [],
        rangosLeyenda: [],
        usarColores: false,
        modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 } },
        cotizadorPlan: { disponible: false, precioHoraDesarrollo: 0, vendedores: [] },
        modalCotizadorPlan: false,
    };

    async componentDidMount() {
        if (this.props.empresaId) {
            this.consultarCotizadorPlan();
            await this.consultarConfiguraciónVencimiento();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.empresaId && !prevProps.empresaId) {
            this.consultarConfiguraciónVencimiento();
            this.consultarCotizadorPlan();
        }
    }

    consultarCotizadorPlan() {
        axios
            .post("cobroBiwo/cotizadorPlanDisponible", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
            .then((res) => {
                if (res.data.success === 2 && res.data.disponible) this.setState({ cotizadorPlan: { disponible: true, precioHoraDesarrollo: res.data.precioHoraDesarrollo, vendedores: res.data.vendedores || [] } });
            })
            .catch(() => {});
    }
    async consultarConfiguraciónVencimiento () {
        axios
        .post(
            "empresas/selectConfiguracionVencimiento",
            {  empresaId: this.props.empresaId },
            { headers: this.props.headersToken }
        )
        .then((res) => {
            if (res.data.success === 2) {
                const { configuracion } = res.data;
                this.setState({
                    usarColores: configuracion.usarColoresCot,
                    rangosLeyenda: configuracion.rangosCotizaciones || []
                });
            }
        })
        .catch((error) => {
            message.error("Error obtiendo la configuración")
        })
    }

    consultarCotizaciones(params) {
        this.setState({ loading: true });
        axios
            .post(
                "cotizaciones/selectCotizaciones",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    const cotizaciones = res.data.data.map((value) => {
                        let numero = value.cotizacionSerie + ' ' + value.cotizacionNumero;
                        return {
                            ...value,
                            fechaCotizacion: value.fechaCotizacion,
                            numero: numero,
                            cliente: value.leyendaCliente ? value.leyendaCliente : ((value.cliente.persona
                                ? value.cliente.razonSocial
                                : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)
                            ) + " - " + value.cliente.rfc),
                            clienteNombre: value.leyendaCliente ? value.leyendaCliente : (value.cliente.persona
                                ? value.cliente.razonSocial
                                : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)),
                            clienteClave: value.cliente.clave || '',
                            clienteNombreComercial: value.cliente.nombreComercial || '',
                            clienteRfc: value.cliente.rfc,
                            vendedor: value.vendedor ? (value.vendedor.nombre + " " + (value.vendedor.apellidoPaterno || "") + ' ' + (value.vendedor.apellidoMaterno || "")) : '',
                            accion: {
                                _id: value._id,
                                estado: value.estado,
                                finiquitada: value.finiquitada,
                                servicios: value.servicios,
                                createdAt: value.createdAt,
                                insumoCambio : value.insumos.some(insumo => insumo?.insumoCambio === true),
                            },
                        };
                    });
                    this.setState({
                        todasCotizaciones: cotizaciones,
                        totalRecords: res.data.totalRecords || 0,
                    });
                } else {
                    this.setState({ todasCotizaciones: [], totalRecords: 0 });
                }
            })
            .catch((error) => {
                console.error('Error al consultar cotizaciones:', error);
                this.setState({ loading: false });
            });
    }

    agregarCotizacion() {
        this.props.history.push("/panel/agregarCotizacion");
    }

    agregarCotizacionConLotes() {
        this.props.history.push("/panel/agregarCotizacionConLotes");
    }

    generarVentaDeCotizacion(value) {
        this.setState({ modalGenerarVenta: true, modalGenerarVentaId: value });
    }

    cerrarGenerarVentaDeContizacion() {
        this.setState({
            modalGenerarVenta: false,
            modalGenerarVentaId: null,
        });
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
    }

    cancelarCotizacion(value) {
        axios
            .post(
                "cotizaciones/cancelarCotizacion",
                { cotizacionId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Cotizacion cancelada");
                } else if (res.data.success === 1) {
                    message.warn(res.data.message);
                } else {
                    message.error("Sucedio un error y no se pudo cancelar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    finiquitarCotizacion(value) {
        axios
            .post(
                "cotizaciones/finiquitarCotizacion",
                { cotizacionId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Cotización finiquitada");
                } else if (res.data.success === 1) {
                    message.warn(res.data.message);
                } else {
                    message.error("Sucedio un error y no se pudo finiquitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    editarCotizacion(id) {
        this.props.history.push("/panel/editarCotizacion", { id });
    }

    // La selección es libre: cualquier cotización se puede marcar, porque también
    // alimenta la descarga masiva. Las reglas de "mismo cliente" y de estado se
    // validan al usar Generar Pedido / Generar Venta.
    onSelectChange = (cotizacionesSeleccionadas) => {

        let encontrarCotizaciones = [];

        for (const cotizacionId of cotizacionesSeleccionadas) {
            const yaGuardada = this.state.objetoCotizacionesEncontradas.find(c => c._id?.toString() === cotizacionId);
            if (yaGuardada) continue;
            const cotizacion = this.state.todasCotizaciones.find(c => c._id?.toString() === cotizacionId);
            if (cotizacion) encontrarCotizaciones.push(cotizacion);
        }

        this.setState({ cotizacionesSeleccionadas, objetoCotizacionesEncontradas: [...this.state.objetoCotizacionesEncontradas, ...encontrarCotizaciones] });
    }

    // Devuelve las cotizaciones de la selección listas para convertirse, o null
    // si alguna no aplica (ya se avisó al usuario).
    cotizacionesParaConvertir() {
        const { cotizacionesSeleccionadas } = this.state;
        if (cotizacionesSeleccionadas.length === 0) {
            message.warn("No hay cotizaciones seleccionadas");
            return null;
        }

        let clienteId = ""

        for (const cotizacionId of cotizacionesSeleccionadas) {
            let cotizacion = this.state.objetoCotizacionesEncontradas.find(c => c._id?.toString() === cotizacionId);
            if (!cotizacion) {
                message.warn("No se encontró la cotización seleccionada");
                return null
            }

            if (cotizacion.estado !== 1 && cotizacion.estado !== 2) {
                message.warn("Solo se pueden usar cotizaciones vigentes o pendientes");
                return null
            }

            if (clienteId) {
                if (clienteId !== cotizacion.clienteId?.toString()) {
                    message.warn("Las cotizaciones seleccionadas no pertenecen al mismo cliente");
                    return null
                }
            } else {
                clienteId = cotizacion.clienteId?.toString()
            }
        }

        return cotizacionesSeleccionadas;
    }

    generarPedidoCotizaciones() {
        const cotizacionesSeleccionadas = this.cotizacionesParaConvertir();
        if (!cotizacionesSeleccionadas) return;

        this.props.history.push("/panel/agregarPedido", { cotizacionesSeleccionadas });
    }

    generarVentaCotizaciones() {
        const cotizacionesSeleccionadas = this.cotizacionesParaConvertir();
        if (!cotizacionesSeleccionadas) return;

        this.props.history.push("/panel/agregarVenta", { cotizacionesSeleccionadas });
    }

    abrirDescarga() {
        this.setState({ modalDescarga: { visible: true, loading: false, progreso: { hechos: 0, total: 0 } } });
    }

    cerrarDescarga() {
        this.setState({ modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 } } });
    }

    async confirmarDescarga(formatos) {
        this.setState((prev) => ({ modalDescarga: { ...prev.modalDescarga, loading: true } }));
        await descargarDocumentosMasivo({
            modulo: "cotizacion",
            ids: this.state.cotizacionesSeleccionadas,
            empresaId: this.props.empresaId,
            headersToken: this.props.headersToken,
            ...formatos,
            onProgreso: (hechos, total) => this.setState((prev) => ({
                modalDescarga: { ...prev.modalDescarga, progreso: { hechos, total } },
            })),
        });
        this.cerrarDescarga();
    }

    duplicarCotizacion(id) {
        this.props.history.push("/panel/agregarCotizacion", { duplicar: id });
    }

    hexToRGBA = (hex, opacity = 0.9) => {
        if (!hex) return 'rgba(255,255,255,0)';
        let r = 0, g = 0, b = 0;
        if (hex.length === 4) {
            r = parseInt(hex[1] + hex[1], 16);
            g = parseInt(hex[2] + hex[2], 16);
            b = parseInt(hex[3] + hex[3], 16);
        } else if (hex.length === 7) {
            r = parseInt(hex[1] + hex[2], 16);
            g = parseInt(hex[3] + hex[4], 16);
            b = parseInt(hex[5] + hex[6], 16);
        }
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    };

    render() {//

        const variablesCSS = {};
        if (this.state.usarColores && this.state.rangosLeyenda.length > 0) {
            this.state.rangosLeyenda.slice(0, 3).forEach((rango, index) => {
                variablesCSS[`--color-rango-${index}`] = this.hexToRGBA(rango.color || '#ffffff');
            });
        }

        const estadosLeyendaDinamicos = this.state.usarColores 
        ? this.state.rangosLeyenda.map((rango, index) => ({
            color: rango.color, 
            label: rango.nombre,
            key: `rango-${index}`,
            tope: rango.tope
        }))
        : [];

        const agregarEquipoMedico = this.props.equipoMedico ? [
        {
            title: "Doctor / Paciente",
            dataIndex: "doctor",
            key: "doctor",
            buscar: "doctor",
            render: (_, record) => (
            <div>
                <div style={{
                fontSize: "12px",
                fontWeight: 500,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
                }}>
                {record.doctor || ""}
                </div>
                <div style={{
                fontSize: "12px",
                color: "#666",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
                }}>
                {(record.paciente || '') + (record.cirugia ? ` - ${record.cirugia}` : '')}
                </div>
            </div>
            ),
            width: "15%",
            ellipsis: true,
        },
        ] : [
        {
            title: "Proyecto",
            dataIndex: "proyecto",
            key: "proyecto",
            responsive: ["md"],
            buscar: 'proyecto',
            render: (value) => <span style={{ fontSize: "11px" }}>{value.nombre}</span>,
            width: "9%",
            ellipsis: true,
        },
        ]

        const columns = [
            {
                title: "Núm/OC",
                dataIndex: "numero",
                key: "numero",
                buscar: "numero",
                sorter: true,
                render: (_, record) => (
                    <div>
                        <div style={{ fontSize: "12px", fontWeight: 500 }}>
                            {record.numero}
                        </div>
                        {record.ordenDeCompra && (
                            <div style={{ fontSize: "12px", color: "#666" }}>
                                OC: {record.ordenDeCompra}
                            </div>
                        )}
                    </div>
                ),
                width: 120,
                ellipsis: true,
            },
            {
                title: "OC",
                dataIndex: "ordenDeCompra",
                key: "ordenDeCompra",
                buscar: "ordenDeCompra",
                responsive: [],
                width: 0,
            },
            ...agregarEquipoMedico,
            {
                title: "Cliente / Vendedor",
                dataIndex: "clienteNombre",
                key: "clienteNombre",
                buscar: "cliente",
                render: (_, record) => (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                        {record.clienteClave ? `${record.clienteClave} - ${record.clienteNombre}` : record.clienteNombre}
                    </span>
                    {/* {record.clienteNombreComercial && (
                        <span style={{ fontSize: "10px", color: "#999", fontStyle: "italic" }}>↳ {record.clienteNombreComercial}</span>
                    )} */}
                    <span style={{ fontSize: "12px", color: "#666" }}>{record.vendedor || "-"}</span>
                    </div>
                ),
                width: window.innerWidth >= 1800 ? "21%" : "23%",
                ellipsis: true,
            },
            {
                title: "RFC",
                dataIndex: "clienteRfc",
                key: "clienteRfc",
                render: (value) => (
                    <div style={{ fontSize: "12px" }}>
                        {value}
                    </div>
                ),
                width: "8%",
                ellipsis: true,
                
            },
            {
                title: "Fecha / Vigencia",
                key: "fechas",
                responsive: ['md'],
                sorter: true,
                render: (_, record) => (
                    <div style={{ fontSize: "12px" }}>
                        {moment(record.fechaCotizacion).locale('es').format('DD/MM/YY')}
                        {record.fechaVigencia && (
                            <> - {moment(record.fechaVigencia).locale('es').format('DD/MM/YY')}</>
                        )}
                    </div>
                ),
                width: "13%",
                ellipsis: true,
                align: "center",
            },
            {
                title: "Subtotal / Total",
                dataIndex: "subtotal",
                key: "subtotal",
                responsive: ["md"],
                sorter: true,
                buscar: "subtotal",
                render: (_, record) => (
                    <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>
                            {dineroDisabledMask(record.subtotal)} {record.moneda}
                        </div>
                        <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                            {dineroDisabledMask(record.total)} {record.moneda}
                        </div>
                    </div>
                ),
                width: 130,
                align: "right",
            },
            {
                title: "Total",
                dataIndex: "total",
                key: "total",
                sorter: true,
                buscar: "total",
                responsive: [],
                width: 0,
            },
            {
                title: "Estado",
                dataIndex: "estado",
                responsive: ['md'],
                key: "estado",
                sorter: true,
                render: (value, record) => {
                    //Una finiquitada queda en Venta o Pedido. Si despues se cancela su venta/pedido, la
                    //reversa recalcula el estado y deja `finiquitada` en true: por eso se exige 3 o 4.
                    if (record?.accion?.finiquitada && (value === 3 || value === 4)) {
                        return (
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                                <Tag color="green" className="square-tag">{value === 3 ? "Venta" : "Pedido"}</Tag>
                                <Tag color="purple" className="square-tag">Finiquitada</Tag>
                            </div>
                        );
                    }
                    if (value === 0) {
                        return <Tag color="red"  className="square-tag">Cancelada</Tag>;
                    }
                    if (value === 1) {
                        return <Tag color="blue" className="square-tag">Vigente</Tag>;
                    }
                    if (value === 2) {
                        return <Tag color="blue" className="square-tag">Pendiente</Tag>;
                    }
                    if (value === 3) {
                        return <Tag color="green"  className="square-tag">Venta</Tag>;
                    }
                    if (value === 4) {
                        return <Tag color="green" className="square-tag">Pedido</Tag>;
                    }
                    if (value === 7) {
                        return <Tag color="orange" className="square-tag">Vencida</Tag>;
                    }
                },
                width: 110,
                ellipsis: true,
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                fixed: "right",
                //El boton Finiquitar solo existe con el complemento; sin el, el ancho queda igual
                width: this.props.finiquitarCotizaciones ? 180 : 150,
                align: "center",
                onCell: () => ({
                    className: "acciones-sin-hover",
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, index) => {
                    if (value.estado === 0) return;
                    let buttons = [];

                    // Botón Editar - siempre visible
                    // Con el complemento activado, una cotización ya convertida (Pendiente, Venta o
                    // Pedido) se edita por completo; el backend conserva su estado y lo ya vendido.
                    const puedeEditarConvertida = this.props.editarCotizacionesTerminadas && [2, 3, 4].includes(value.estado);
                    const puedeEditar = value.estado === 1 || value.estado === 7 || puedeEditarConvertida;
                    buttons.push(
                        <Tooltip title={puedeEditar ? "Editar" : "No se puede editar"} placement="top">
                            <ButtonItem
                                key={`edit-${index}`}
                                type="default"
                                size="small"
                                cyan
                                icon={<EditOutlined />}
                                onClick={() => puedeEditar && this.editarCotizacion(value._id)}
                                disabled={!puedeEditar}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    const puedeGenerarVenta =  !value.insumoCambio && (value.estado === 1) && this.props.permisoGenerarVenta && (moment(value.createdAt) > moment("2024-11-28T00:24:20.636+00:00"));
                    buttons.push(
                        <Tooltip title={puedeGenerarVenta ? "Generar Venta" : "No disponible"} placement="top">
                            <ButtonItem
                                key={`generar-venta-${index}`}
                                type="default"
                                size="small"
                                lima
                                icon={<ShoppingCartOutlined />}
                                onClick={() => puedeGenerarVenta && this.generarVentaDeCotizacion(value._id)}
                                disabled={!puedeGenerarVenta}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                
                    const puedeCancelar = value.estado !== 0 && value.estado !== 3 && value.estado !== 2 && value.estado !== 4 && this.props.permisoCancelarCotizaciones;
                    buttons.push(
                        <Popconfirm
                            key={`cancelar-${index}`}
                            title={'¿Seguro que quiere cancelar esta cotización?'}
                            onConfirm={() => this.cancelarCotizacion(value._id)}
                            okText="Sí"
                            cancelText="No"
                            disabled={!puedeCancelar}
                        >
                            <Tooltip title={puedeCancelar ? "Cancelar" : "No se puede cancelar"} placement="top">
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    rojo
                                    icon={<CloseCircleOutlined />}
                                    disabled={!puedeCancelar}
                                >
                                </ButtonItem>
                            </Tooltip>
                        </Popconfirm>
                    );

                    if (this.props.finiquitarCotizaciones) {
                        const puedeFiniquitar = value.estado === 2 && this.props.permisoCancelarCotizaciones;
                        buttons.push(
                            <Popconfirm
                                key={`finiquitar-${index}`}
                                title={'¿Seguro que quiere finiquitar esta cotización?'}
                                onConfirm={() => this.finiquitarCotizacion(value._id)}
                                okText="Sí"
                                cancelText="No"
                                disabled={!puedeFiniquitar}
                            >
                                <Tooltip title={puedeFiniquitar ? "Finiquitar" : "No se puede finiquitar"} placement="top">
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        morado
                                        icon={<CheckCircleOutlined />}
                                        disabled={!puedeFiniquitar}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    }

                    buttons.push(
                        <Tooltip title={"Duplicar Cotización"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                        <ButtonItem
                            key={`duplicar-${index}`}
                            type="default"
                            size="small"
                            lila
                            icon={<CopyOutlined />}
                            onClick={() => this.duplicarCotizacion(value._id)}
                        >
                        </ButtonItem>
                        </Tooltip>
                    );

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];

        return (
            <div style={variablesCSS}>
                <PageHeader
                    title="Cotizaciones"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[
                                        { label: 'Vigente', value: 1 },
                                        { label: 'Pendiente', value: 6 },
                                        { label: 'Vencida', value: 2 },
                                        { label: 'Venta', value: 3 },
                                        { label: 'Pedido', value: 7 },
                                        { label: 'Cancelada', value: 4 },
                                        { label: 'Todos', value: 5 }
                                    ]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({ valor: value });
                                        }
                                        this.setState({ valor: value });
                                    }}
                                    value={this.state.valor}
                                />
                            }
                            {this.props.permisoAgregarCotizaciones && this.props.taxidermia &&
                                <ButtonItem
                                    type="primary"
                                    olivo
                                    key="agregarCotizacionConLotes"
                                    onClick={this.agregarCotizacionConLotes.bind(this)}
                                     className="botonAgregar"
                                >
                                    Agregar Cotizacion Con Animales
                                </ButtonItem>}
                            {(this.props.permisoVerCotizaciones && this.state.cotizacionesSeleccionadas.length > 0) &&
                                <ButtonItem
                                    blanco
                                    icon={<DownloadOutlined />}
                                    key="descargarCotizaciones"
                                    style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                                    onClick={this.abrirDescarga.bind(this)}
                                >
                                    Descargar ({this.state.cotizacionesSeleccionadas.length})
                                </ButtonItem>}
                            {(this.props.permisoAgregarCotizaciones && this.state.cotizacionesSeleccionadas.length > 0) && //!this.props.taxidermia &&
                                <ButtonItem
                                    type="primary"
                                    azulMarino
                                    style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                                    key="generarPedidoCotizaciones"
                                    onClick={this.generarPedidoCotizaciones.bind(this)}
                                >
                                    Generar Pedido
                             </ButtonItem>}
                            {(this.props.permisoAgregarCotizaciones && this.state.cotizacionesSeleccionadas.length > 0) &&
                                <ButtonItem
                                    type="primary"
                                    cyan
                                    key="generarVentaCotizaciones"
                                    onClick={this.generarVentaCotizaciones.bind(this)}
                                    className="botonAgregar"
                                >
                                    Generar Venta
                                </ButtonItem>}
                            {this.props.permisoAgregarCotizaciones && this.state.cotizadorPlan.disponible &&
                                <ButtonItem
                                    type="primary"
                                    key="cotizarPlanBiwo"
                                    azulMarino
                                    onClick={() => this.setState({ modalCotizadorPlan: true })}
                                    className="botonAgregar"
                                >
                                    Cotizar plan BIWO
                                </ButtonItem>
                            }
                            {this.props.permisoAgregarCotizaciones && 
                                <ButtonItem
                                    type="primary"
                                    key="agregarCotizacion"
                                    olivo
                                    onClick={this.agregarCotizacion.bind(this)}
                                    className="botonAgregar"
                                >
                                    Agregar Cotización
                                </ButtonItem>
                            }
                        </div>
                    }
                />

                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    onlyMineFilter
                    onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                if (this.props.permisoVerCotizaciones) {
                                    this.props.history.push("/panel/verCotizacion", { id: record._id });
                                }
                            },
                        };
                    }}
                    anadirValorFiltro={this.state.valor}
                    onFetchData={this.consultarCotizaciones.bind(this)}
                    loading={this.state.loading}
                    size="small"
                    scroll={{ x: "max-content" }} // o un número, p.ej. { x: 1400 }
                    dataSource={this.state.todasCotizaciones}
                    columns={columns}
                    filterStorageKey={"cotizacionesFiltrosTabla" + this.props.empresaId}
                    pagination={false}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                    setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
                    valorTextoDefault={""}
                    rowSelection={{
                        selectedRowKeys: this.state.cotizacionesSeleccionadas,
                        onChange: this.onSelectChange.bind(this),
                        // La tabla pagina del lado del servidor: sin esto, antd
                        // tira las llaves de las páginas anteriores al paginar.
                        preserveSelectedRowKeys: true,
                    }}
                    estadosLeyenda={estadosLeyendaDinamicos}

                />

                {this.state.cotizadorPlan.disponible && (
                    <CotizadorPlanBiwo
                        visible={this.state.modalCotizadorPlan}
                        precioHoraDesarrollo={this.state.cotizadorPlan.precioHoraDesarrollo}
                        vendedores={this.state.cotizadorPlan.vendedores}
                        onCancel={() => this.setState({ modalCotizadorPlan: false })}
                        onCotizacionLista={(planBiwo) => {
                            this.setState({ modalCotizadorPlan: false });
                            this.props.history.push("/panel/agregarCotizacion", { planBiwo });
                        }}
                    />
                )}

                <GenerarVenta
                    visible={this.state.modalGenerarVenta}
                    id={this.state.modalGenerarVentaId}
                    cerrarGenerarVentaDeContizacion={this.cerrarGenerarVentaDeContizacion.bind(this)}
                />

                <ModalDescargarDocumentos
                    visible={this.state.modalDescarga.visible}
                    loading={this.state.modalDescarga.loading}
                    progreso={this.state.modalDescarga.progreso}
                    total={this.state.cotizacionesSeleccionadas.length}
                    tieneXml={MODULOS.cotizacion.tieneXml}
                    onClose={this.cerrarDescarga.bind(this)}
                    onConfirm={this.confirmarDescarga.bind(this)}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        equipoMedico: state.empresa.equipoMedico,
        taxidermia: state.empresa.taxidermia,
        editarCotizacionesTerminadas: state.empresa.editarCotizacionesTerminadas,
        finiquitarCotizaciones: state.empresa.finiquitarCotizaciones,
        permisoAgregarVenta:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ccb6bf30e81b54183cf70"
            )?.activado,
        permisoAgregarCotizaciones:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750922d798d4e0043687242"
            )?.activado,
        permisoCancelarCotizaciones:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750922d798d4e0043687242"
            )?.activado,
        permisoVerCotizaciones:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750925b798d4e0043687244"
            )?.activado,
        permisoGenerarVenta:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750926d798d4e0043687245"
            )?.activado,
    };
};

export default connect(mapStateToProps)(Cotizaciones);